import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "../lib/cx.js";
const variantClass = {
    primary: "evolua-btn evolua-btn--primary",
    secondary: "evolua-btn",
    danger: "evolua-btn evolua-btn--danger",
    ghost: "evolua-btn evolua-btn--ghost",
    tertiary: "evolua-btn evolua-btn--tertiary",
};
export function buttonClassName({ variant = "primary", size = "md", fullWidth, className, }) {
    return cx(variantClass[variant], size === "sm" && "evolua-btn--sm", size === "lg" && "evolua-btn--lg", fullWidth && "evolua-btn--block", className);
}
export function Button({ children, variant = "primary", size = "md", type = "button", className, loading = false, fullWidth, iconStart, iconEnd, disabled, ...rest }) {
    return (_jsxs("button", { type: type, className: buttonClassName({
            variant,
            size,
            ...(fullWidth ? { fullWidth: true } : {}),
            ...(className ? { className } : {}),
        }), disabled: disabled || loading, "aria-busy": loading || undefined, ...rest, children: [loading ? _jsx("span", { className: "evolua-spinner", "aria-hidden": "true" }) : iconStart, children, loading ? null : iconEnd] }));
}
//# sourceMappingURL=Button.js.map